import HttpClient from '../../adapter/HttpClient';
import BfOrganization from '../../entity/BfOrganization';
import BudgetSummary from '../../entity/BudgetSummary';
import PointTransactionHistory from '../../entity/PointTransactionHistory';

class BfWebApi {
  private httpClient: HttpClient;

  constructor({ httpClient }: { httpClient: HttpClient }) {
    this.httpClient = httpClient;
  }

  public getOrganization = async (id: string): Promise<BfOrganization> => {
    const ret = await this.httpClient.get(`/bf/organizations/${id}`);
    return BfOrganization.fromJSON(ret.data.data);
  };

  public getBudget = async (kaizenUserId: string): Promise<BudgetSummary> => {
    const ret = await this.httpClient.get(`/bf/organizations/${kaizenUserId}/budgets?details=1`);
    return BudgetSummary.fromJSON(ret.data.data);
  };

  public getPointTransactions = async (kaizenUserId: string): Promise<PointTransactionHistory> => {
    const ret = await this.httpClient.get(`/bf/organizations/${kaizenUserId}/point_transactions`);
    return PointTransactionHistory.fromJSON(ret.data.data);
  };
}

export default BfWebApi;
